import React, { memo } from 'react';

import newBotImg from '../../../assets/images/icone_newbot.svg';
import Toggle from '../../Elements/Toggle';

import './BotHeader.scss';

import iconData from '../../../assets/images/icon_data.svg';
import { dateToString } from '../../../util/date';

const BotHeader = (props) => {
  const { bot, img, updateBotStatus, user } = props;

  // const { i18n } = useTranslation();

  const onToggleChanged = (e) => {
    // console.log('onToggleChanged', e.target.checked);
    updateBotStatus(
      bot._id,
      !bot.isActive ? 'Online' : 'Offline',
      !bot.isActive
    );
  };

  const creation = dateToString(bot ? bot.creationDate : '', 'dd/MM/yyyy');
  const creationText = `Bot criado em: ${creation}`;

  return (
    <div className="col-md-12 d-flex justify-content-center bot-header">
      <div className="col-md-10">
        <div className="float-left">
          <img
            src={img || bot.img || newBotImg}
            className="float-left bot-header-img"
            alt=""
          />
          <div className="bot-control">
            <span>{bot.title || ''}</span>
            <Toggle
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              className="bot-header-toggle"
              checked={bot.isActive}
              label={bot && bot.isActive ? 'Online' : 'Offline'}
              onChange={onToggleChanged}
            />
          </div>
        </div>
        <div className="float-right text-right bot-header-info">
          <div>ID: {bot ? bot._id : '-'}</div>
          <div>
            <img src={iconData} alt="" />
            {creationText}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(BotHeader);
